import { extend } from 'vee-validate';
import { required, numeric, email, required_if, confirmed, min, regex } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: '{_field_} is required.'
});

extend('numeric', {
    ...numeric,
    message: '{_field_} must be numeric.'
});

extend('date', {
    validate(value) {
        return (/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/.test(value));
    },
    message: '{_field_} is invalid. (yyyy-mm-dd)'
});

extend('email', {
    ...email,
    message: '{_field_} is not valid.'
});

extend('required_if', {
    ...required_if,
    message: '{_field_} is required.'
});

extend('confirmed', {
    ...confirmed,
    message: '{_field_} must match {target}'
});

extend('min', {
    ...min,
    message: '{_field_} must be at least {length} characters'
});

extend('regex', regex);